import { updateCity } from 'shared/slices/geo';
import { updateRegion } from 'shared/thunks/jsonQuery';
import { updateSearchMeta } from 'shared/thunks/searchMeta';
import { ILocation } from 'shared/types/location';
import { TAsyncThunkAction } from 'shared/types/redux';

export const selectCity =
  (city: ILocation): TAsyncThunkAction =>
  async dispatch => {
    dispatch(updateCity(city));
    dispatch(updateRegion(city));
    dispatch(updateSearchMeta());
  };
